import { createSlice } from "@reduxjs/toolkit";
import Immutable from "immutable";
import CommonBase from "../../../../share/base/network/axiosNetwork";

const initialState = Immutable.fromJS({
  walletInfo: null,
  isLoading: false,
});

export const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    FETCH_WALLET_START: function (state) {
      return state.set("isLoading", true);
    },
    FETCH_WALLET_SUCCESS: function (state, action) {
      return state.set("walletInfo", action.payload).set("isLoading", false);
    },
    FETCH_WALLET_FAILURE: function (state) {
      return state.set("isLoading", false);
    },
  },
});

export const {
  FETCH_WALLET_START,
  FETCH_WALLET_SUCCESS,
  FETCH_WALLET_FAILURE,
} = walletSlice.actions;

export const reloadWallet = () => async (dispatch) => {
  dispatch(FETCH_WALLET_START());
  const response = await CommonBase.getAsync("/api/wallets/me");
  console.log("Wallet data:", response.data);
  if (response.data) {
    dispatch(FETCH_WALLET_SUCCESS(response.data));
  } else {
    dispatch(FETCH_WALLET_FAILURE());
  }
};

export default walletSlice.reducer;
